import { Radio } from 'antd';

import './styles.scss';

const RadioButton = ({
    title = '',
    labelWidth = '100px',
    options = [],
    onChange = () => { },
    value,
    ...props
}) => {
    return (<div className='radio-container'>
        {title && <div className='radio-title' style={{
            width: labelWidth
        }}>{title}</div>}

        <Radio.Group onChange={onChange} value={value} {...props} className='radio-group'>
            {
                options?.map((item, idx) => <Radio key={idx} value={item?.value}>{item?.title}</Radio>)
            }
        </Radio.Group>

    </div>
    );
}

export default RadioButton